// extracted by css-extract-rspack-plugin
export default {"link":"_ca0227e0"};